import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { NotificationMessageComponent } from 'src/app/dialogs/notification-message/notification-message.component';
import { DialogService } from 'src/app/services/dialog.service';
import { BooleanCons, MessageType, StringConst, TypesImages } from '../../constants/const';
import { Messages } from '../../constants/messages';
import { TypeIcon } from '../../model/device/message.model';
import { FileSelectedResult } from '../../model/local/general.model';
import { CommonService } from '../../services/common.service';

@Component({
  selector: 'app-file-selected',
  templateUrl: './file-selected.component.html',
  styleUrls: ['./file-selected.component.scss']
})
export class FileSelectedComponent implements OnInit {
  @Output() fileSelectedResult = new EventEmitter<FileSelectedResult>();
  @Input() isForChangeImage = false;
  @Input() shouldUpdateProfilePhoto = false;
  @Input() isLateralMenu = false;
  @Input() coverButton = BooleanCons.false;
  @Input() typeImageToSave = StringConst.empty;
  controlImage = new FormControl('', []);
  constructor(
    private commonService: CommonService,
    private dialogService: DialogService) { }

  ngOnInit(): void {
  }
  handleUpload(event: any): void {
    const fileSelected: File = event.target.files[0];
    const typeImage = this.commonService.getTypeImage(fileSelected.type);
    this.controlImage.reset();
    if (!TypesImages.includes(typeImage)) {
      this.generateMessage(Messages.typeImageError);
      return;
    }
    if ((fileSelected.size / 1024 / 1024) > 4) {
      this.generateMessage(Messages.sizeImageError);
      return;
    }

    const reader = new FileReader();
    reader.readAsDataURL(fileSelected);
    reader.onload = () => {
      this.fileSelectedResult.emit({
        type: typeImage, base64: this.commonService.getOnlyBase64(reader.result),
        isUpdate: true, file: fileSelected, typeImageToSave: this.typeImageToSave
      });
    };
  }

  generateMessage(textToShow: string): void {
    this.dialogService.openNotificationGeneric(NotificationMessageComponent, {
      typeIcon: TypeIcon.info,
      textToShow, typeMessage: MessageType.default,
      isButtonCancel: false
    });
  }
}
